export default {
  label: 'Discuter avec notre équipe',
  label_unread: 'Discuter avec notre équipe, {{count}} nouveau(x)',
};
